export default "__VITE_ASSET__$FBPmcnh__"